import {
  toCyrillicKeyboardMap,
  toLatinKeyboardMap,
  toLatinMap
} from './constants'

export const toLatin = (origText: string): string[] => {
  const outputs: string[][] = [[]]
  const text = origText.toLowerCase()

  for (const partText of text) {
    if (toCyrillicKeyboardMap[partText]) {
      return [origText]
    }

    const valueOrArray = toLatinMap[partText]
    if (Array.isArray(valueOrArray)) {
      valueOrArray.forEach(value => {
        outputs.forEach(arr => {
          arr.push(value)
        })
      })
    } else {
      outputs.forEach(arr => {
        arr.push(valueOrArray)
      })
    }
  }

  return outputs.map(arr => arr.join(''))
}

export const toLatinKeyboard = (origText: string): string => {
  const output = []
  const text = origText.toLowerCase()

  for (let i = 0; i < text.length; i++) {
    const char = text.slice(i, i + 1)
    if (toLatinKeyboardMap[char]) {
      output.push(toLatinKeyboardMap[char])
      continue
    }

    if (toCyrillicKeyboardMap[char]) {
      return origText
    }

    output.push(char)
  }

  return output.join('')
}
